import { apiServices } from '../services/api.services';
import store from '../store';
import { toast } from 'react-toastify';
import i18n from '../../i18n';

export const getPayments = (force = false) => {
  const { init } = store.getState().payments;
  if (!store.getState().infos.uid) {
    setTimeout(() => {
      getPayments(force)
    }, 1000);
  } else {
    if (init && !force) return;
    apiServices.get("/payments").then((res) => {
      if (res && res.data && !res.data.error) {
        return store.dispatch({type: 'PAYMENTS_SET_LIST', list: res.data});
      }
    }).catch(err => {
        return console.log(err);
    });
  }
};

export const closePaymentModal = () => {
  return async (Dispatch) => {
      Dispatch({type: "PAYMENT_CLOSE_MODAL"});
  };
}

export const openPaymentModal = (paymentData, paymentInfos, date) => {
  return async (Dispatch) => {
      Dispatch({
        type: "PAYMENT_SET_MODAL",
        payer: paymentData.payer,
        id: paymentData.id,
        creation: date,
        paymentInfos
      });
  };
}

export const cancelSubscription = (id) => {
  apiServices.post("/cancelSubscription", { id }).then((response) => {
      if (!response.data.success)
            return toast.error(i18n.t(`profile:payment.errorCancelSubscription`));
      else {
        store.dispatch({type: 'CANCEL_SUBSCRIPTION', id});
        return toast.success(response.datai18n.t(`profile:payment.succesCancelSubscription`));
      }
  }).catch(err => {
      return err;
  });
}

export const paymentSetVip = (vip) => {
  return async (Dispatch) => {
    Dispatch({type: "UPDATE_VIP_SELECTED", vip});
  };
}
export const paymentSetPaymentType = (paymentType) => {
  console.log('paymentSetPaymentType: ', paymentType);
  return async (Dispatch) => {
    Dispatch({type: "UPDATE_PAYMENT_TYPE", paymentType});
  };
}

export const paymentSetSubTime = (subTime) => {
  if (isNaN(subTime)) return false;
  if (subTime < 1 || subTime > 12) return false;
  return async (Dispatch) => {
    Dispatch({type: "UPDATE_SUB_TIME", subTime});
  };
}

export const paymentSetStep = (step) => {
  return async (Dispatch) => {
    Dispatch({type: "UPDATE_STEP", step});
  };
}

export const paymentSetMethod = (paymentMethod) => {
  if (!["paypal"].includes(paymentMethod)) return false;
  return async (Dispatch) => {
    Dispatch({type: "UPDATE_PAYMENT_METHOD", paymentMethod});
  };
}